import { useContractFunction, useEthers } from "@usedapp/core";
import { Contract } from "ethers/lib/ethers";
import { useCallback, useEffect, useState } from "react";
import ERC721_INTERFACE from "../../constants/erc721";

export enum ApproveState {
  UNAPPROVED,
  PENDING,
  APPROVED,
}

//Checks if an nft contract is approved
//Returns the approve state and callback that will call the approve function
export const useApprovalForAll = (
  nft_contract_addr: string, //The contract address of the nft
  address_operator: string //The contract that needs approval to transfer the nft
) => {
  const [isApproved, setIsApproved] = useState(ApproveState.UNAPPROVED);

  const { account, library, chainId } = useEthers();

  const contract = new Contract(
    nft_contract_addr,
    ERC721_INTERFACE,
    library ? library.getSigner() : undefined
  );
  const { state, send } = useContractFunction(contract, "setApprovalForAll");

  //Update approval once account is available
  useEffect(() => {
    if (account) {
      try {
        contract
          .isApprovedForAll(account, address_operator)
          .then((response) => {
            if (response === true) {
              setIsApproved(ApproveState.APPROVED);
            } else {
              setIsApproved(ApproveState.UNAPPROVED);
            }
          });
      } catch (error) {
        console.log(error);
      }
    }
  }, [account]);

  //Returns memoized function for send
  const setApprovalForAll = useCallback(() => {
    send(address_operator, true);
  }, [account, library, chainId]);

  useEffect(() => {
    //Update the approval state depending on the transaction state
    if (state.status === "Mining") {
      setIsApproved(ApproveState.PENDING);
    } else if (state.status === "Success") {
      setIsApproved(ApproveState.APPROVED);
    } else {
      setIsApproved(ApproveState.UNAPPROVED);
    }
  }, [state]);

  return { isApproved, setApprovalForAll };
};
